<template>
  <div>
    <default-table
      :items="listaMonitoramentoConsumos"
      :fields="fields"
      :striped="false"
      :busy="flags.carregandoDados.status"
      :tbody-tr-class="definirClasseLinha"
      :head-variant="'light'"
      :hover="false"
      :bordered="false">
      <template #empty>
        <em>Nenhum registro encontrado.</em>
      </template>
      <template #cell(descricao)="row">
        <b-img :src="obterIcone(row.item.icone)" :blank="!row.item.icone" width="18"  height="18"  class="icone" alt="Fluid image"></b-img>
        <span class="ml-3">{{row.item.nome}}</span>
      </template>
      <template #cell(plano)="row">
        <span class="d-block text-center">{{ formatarCampo(row.item['itens'].plano, row.field.key, row)}}</span>
      </template>
      <template #cell(adicional)="row">
        <span class="d-block text-center">{{ formatarCampo(row.item['itens'].adicional, row.field.key, row)}}</span>
      </template>
      <template #cell(utilizado)="row">
        <span class="d-block text-center">{{ formatarCampo(row.item['itens'].utilizado, row.field.key, row)}}</span>
      </template>
      <template #cell(saldo)="row">
        <span class="d-block text-center">{{ formatarCampo(row.item['itens'].saldo, row.field.key, row)}}</span>
      </template>
    </default-table>
  </div>
</template>

<script>
import MonitoramentoConsumo from './js/monitoramento-consumo.js'
export default MonitoramentoConsumo
</script>

<style scoped>
@import "./scss/monitoramento-consumo.scss";
</style>
